import React from "react";

// material ui
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

// icons
import AddIcon from "@material-ui/icons/Add";
import { Delete } from "@material-ui/icons";

// jazasoft
import { Button } from "jazasoft";

import Table, { TextInput } from "../../../../components/Table";

const PlyLimitDialog = ({ open, onClose, rows, setRows }) => {
  const onChange =
    ({ rowIdx, column }) =>
    event => {
      const value = event.target.value;
      setRows(rows => {
        let newRows = [...rows];
        let row = { ...rows[rowIdx], [column.dataKey]: value };
        newRows.splice(rowIdx, 1, row);
        return newRows;
      });
    };

  const onAddRow = () => {
    setRows(prev => [...prev, {}]);
  };

  const onDeleteRow = props => {
    const { rowIdx } = props;
    const newRows = [...rows];
    newRows.splice(rowIdx, 1);
    setRows([...newRows]);
  };

  const columns = [
    {
      dataKey: "way",
      title: "Way",
      element: <TextInput onChange={onChange} type="number" inputProps={{ style: { textAlign: "center" } }} />,
      align: "center"
    },
    {
      dataKey: "value",
      title: "Value",
      element: <TextInput onChange={onChange} type="number" inputProps={{ style: { textAlign: "center" } }} />,
      align: "center"
    },
    {
      dataKey: "action",
      title: "Action",
      element: props => (
        <span
          style={{ cursor: "pointer", color: "#b22222" }}
          onClick={() => {
            onDeleteRow(props);
          }}>
          <Delete />
        </span>
      ),
      aligen: "center"
    }
  ];

  return (
    <Dialog id="adjust-dialog" fullWidth={true} maxWidth="sm" open={open} onClose={onClose}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <DialogTitle id="import-dialog-title">Ply Limit</DialogTitle>
        <AddIcon style={{ marginRight: 10, cursor: "pointer" }} onClick={onAddRow} />
      </div>
      <Divider />
      <Table toolbar columns={columns} rows={rows} />
      <div style={{ display: "flex", justifyContent: "flex-end", padding: "1.5em" }}>
        <Button label="Close" variant="outlined" color="primary" onClick={onClose} />
      </div>
    </Dialog>
  );
};

export default PlyLimitDialog;
